import "core-js/modules/es6.object.assign";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import PropTypes from "prop-types";
import { makePropTypesFactory, makeValidatingTransformFactory } from "./factory";
export var makePropTypes = makePropTypesFactory(function (vars) {
  return {
    clipped: PropTypes.bool
  };
});
export var transform = function transform(props) {
  var className = props.className,
      clipped = props.clipped,
      rest = tslib_1.__rest(props, ["className", "clipped"]);

  return Object.assign({
    className: classNames({
      "is-clipped": clipped
    }, className)
  }, rest);
};
export var makeValidatingTransform = makeValidatingTransformFactory(makePropTypes, transform);